export const FakeFeatures = [
  {
    id: "001",
    title: "Easy Appointment",
    description:
      "Experience hassle-free appointment scheduling with our intuitive system.",
    img: "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Features/feature1.svg",
  },
  {
    id: "002",
    title: "Emergency Service",
    description:
      " Access our emergency service for immediate assistance when you need it the most.",
    img: "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Features/feature2.svg",
  },
  {
    id: "003",
    title: "24/7 Service",
    description:
      "Enjoy round-the-clock service availability to cater to your dental needs at any time.",
    img: "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Features/feature3.svg",
  },
];
